import React from 'react';
import { Link } from 'react-router-dom';
import './advocacy.css';
import { FaEye, FaHandsHelping, FaUsers, FaChartLine, FaRegLightbulb } from 'react-icons/fa';

function Advocacy() {
  return (
    <div className="advocacy-container">
      {/* Hero Section */}
      <section className="advocacy-hero">
        <div className="hero-content">
          <h1 className='cecoa-heading'>Advocacy</h1>
          <p className="cecoa-subtitle">
            Championing eye health awareness, professional standards, and policy changes to improve vision care nationwide
          </p>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="mission-section">
        <div className="mission-content">
          <h2>Our Advocacy Mission</h2>
          <p>
            The Ceylon Eye Care Optometry Association is committed to being the leading voice for optometric professionals 
            and the public we serve. We work tirelessly to promote eye health as a fundamental right, advocate for 
            evidence-based practice standards, and influence health policy to ensure accessible, quality vision care for all Sri Lankans.
          </p>
        </div>
      </section>

      {/* Key Advocacy Areas */}
      <section className="key-areas-section">
        <h2 className="section-title">Our Key Advocacy Areas</h2>
        <div className="key-areas-grid">
          <div className="advocacy-card">
            <div className="card-icon">
              <FaEye />
            </div>
            <h3>Public Eye Health Awareness</h3>
            <ul>
              <li>National vision screening programs</li>
              <li>School eye health initiatives</li>
              <li>Public education campaigns</li>
            </ul>
          </div>

          <div className="advocacy-card">
            <div className="card-icon">
              <FaHandsHelping />
            </div>
            <h3>Professional Standards</h3>
            <ul>
              <li>Advancing optometric education</li>
              <li>Continuing professional development</li>
              <li>Ethical practice guidelines</li>
            </ul>
          </div>

          <div className="advocacy-card">
            <div className="card-icon">
              <FaUsers />
            </div>
            <h3>Patient Rights</h3>
            <ul>
              <li>Access to quality eye care</li>
              <li>Affordable vision correction</li>
              <li>Informed consent education</li>
            </ul>
          </div>

          <div className="advocacy-card">
            <div className="card-icon">
              <FaChartLine />
            </div>
            <h3>Policy & Legislation</h3>
            <ul>
              <li>Health ministry engagement</li>
              <li>Optometry practice regulations</li>
              <li>Insurance coverage expansion</li>
            </ul>
          </div>
        </div>
      </section>

{/* Networking Programs */}
<section className="networking-section">
  <h2 className="section-title">Professional Networking Programs</h2>
  
  <div className="networking-card">
    <div className="networking-image">
    <img src='/faq.jpg' />
    </div>
    <div className="networking-content">
      <h3>Networking Event</h3>
      <p className="networking-description">
        Our premier networking event connecting optometrists across Sri Lanka with industry leaders, 
        equipment manufacturers, and international experts to foster professional relationships and knowledge exchange.
      </p>
      <div className="networking-stats">
        <div className="stat-item">
          <strong>300+</strong>
          <span>Professionals Attended</span>
        </div>
        <div className="stat-item">
          <strong>15+</strong>
          <span>The Industry Exhibitors</span>
        </div>
      </div>
    </div>
  </div>

  <div className="networking-card reverse">
    <div className="networking-image" >

    </div>
    <div className="networking-content">
      <h3>Regional Practitioner Meetups</h3>
      <p className="networking-description">
        Quarterly gatherings in major cities connecting local optometrists for peer discussions, 
        case studies, and building referral networks within their communities.
      </p>
      <div className="upcoming-events">
        <h4>Upcoming Events:</h4>
        <ul className="event-list">
          <li>Colombo - October 15, 2023</li>
          <li>Kandy - November 5, 2023</li>
          <li>Galle - December 3, 2023</li>
        </ul>
      </div>
    </div>
  </div>
</section>






<div className="cecoa-advocacy">
  <div className="cecoa-advocacy__wrapper">
    <div className="cecoa-advocacy__intro">
      <h2 className="cecoa-advocacy__title">Advancing Optometry Standards in Sri Lanka</h2>
      <div className="cecoa-advocacy__divider"></div>
      <p className="cecoa-advocacy__description">
        The Ceylon Eye Care Optometry Association is committed to elevating eye care standards 
        through professional collaboration, evidence-based practice, and continuous education.
      </p>
    </div>

    <div className="cecoa-advisory">
      <div className="cecoa-advisory__content">
        <h1 className="cecoa-advisory__heading">Eye Care Standards Advisory Group</h1>
        
        <div className="cecoa-advisory__grid">
          <div className="cecoa-advisory__panel cecoa-advisory__panel--mission">
            <h3 className="cecoa-advisory__subheading">Our Mission</h3>
            <p className="cecoa-advisory__text">
              The advisory group brings together leading optometrists, ophthalmologists, 
              and vision scientists to establish best practices, develop clinical guidelines, 
              and advocate for quality eye care standards across Sri Lanka.
            </p>
            <ul className="cecoa-advisory__features">
              <li className="cecoa-advisory__feature-item">Develop evidence-based clinical protocols</li>
              <li className="cecoa-advisory__feature-item">Advocate for patient-centered care standards</li>
              <li className="cecoa-advisory__feature-item">Promote continuing education for practitioners</li>
            </ul>
          </div>

          <div className="cecoa-advisory__panel cecoa-advisory__panel--initiatives">
            <h3 className="cecoa-advisory__subheading">Key Initiatives</h3>
            <div className="cecoa-advisory__initiatives">
              <div className="cecoa-advisory__initiative">
                <h4 className="cecoa-advisory__initiative-title">National Standards Framework</h4>
                <p className="cecoa-advisory__initiative-desc">
                  Developing comprehensive guidelines for optometric practice in Sri Lanka.
                </p>
              </div>
              <div className="cecoa-advisory__initiative">
                <h4 className="cecoa-advisory__initiative-title">Public Awareness Campaigns</h4>
                <p className="cecoa-advisory__initiative-desc">
                  Educating the public about eye health and preventive care.
                </p>
              </div>
              <div className="cecoa-advisory__initiative">
                <h4 className="cecoa-advisory__initiative-title">Professional Accreditation</h4>
                <p className="cecoa-advisory__initiative-desc">
                  Establishing certification programs for optometry professionals.
                </p>
              </div>
            </div>
            <Link to="/jointoeffort">
            <button className="cecoa-advisory__cta">
              Join Our Efforts
            </button></Link>
          </div>
        </div>
      </div>
    </div>

    <div className="cecoa-advocacy__statement">
      <p className="cecoa-advocacy__quote">
        "Together, we're shaping the future of eye care in Sri Lanka through 
        collaboration, innovation, and professional excellence."
      </p>
    </div>
  </div>
</div>





      {/* Policy Successes */}
      <section className="success-stories">
        <h2 className="section-title">Our Policy Achievements</h2>
        <div className="success-grid">
          <div className="success-item">
            <FaRegLightbulb className="success-icon" />
            <h3>Recognition of Optometrists</h3>
            <p>Successfully advocated for official recognition of optometrists as primary eye care providers in the national health policy (2021).</p>
          </div>
          <div className="success-item">
            <FaRegLightbulb className="success-icon" />
            <h3>Spectacle Subsidy Program</h3>
            <p>Instrumental in establishing a government subsidy program for low-income individuals needing corrective lenses (2022).</p>
          </div>
          <div className="success-item">
            <FaRegLightbulb className="success-icon" />
            <h3>Continuing Education Mandate</h3>
            <p>Implemented mandatory continuing education requirements for optometry license renewal (2020).</p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Join Our Advocacy Efforts</h2>
          <p>
            Whether you're an optometry professional, health advocate, or concerned citizen, your voice matters 
            in our mission to improve eye care in Sri Lanka.
          </p>
          <div className="cta-buttons">
            <Link to="/advocacyvolunteer">
            <button className="primary-cta">Become an Advocacy Volunteer</button></Link>

            {/* <Link to="/policyalert">
            <button className="secondary-cta">Sign Up for Policy Alerts</button></Link> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Advocacy;